import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import Vant from 'vant'
import './filters'
import 'vant/lib/index.css'
import '@/components/index'
import VueClipboard from 'vue-clipboard2'
import VConsole from 'vconsole'
import { generateUuid } from '@/utils/getInfo'

// 调式工具 开发环境才会开启
// eslint-disable-next-line no-new
console.log(process.env)

const isDev = process.env.NODE_ENV === 'development'
// 本地环境和测试环境
if (isDev) {
  // eslint-disable-next-line no-new
  new VConsole()
}

const context = require.context('./plugins/', false, /.js$/)
context.keys().forEach(item => {
  const result = item.match(/.\/(\w+).js$/)
  if (result) {
    Vue.use(context(item).default)
  }
})
if (!localStorage.getItem('deviceNo')) {
  localStorage.setItem('deviceNo', generateUuid())
}

if (!localStorage.getItem('userRandomKey')) {
  localStorage.setItem('userRandomKey', generateUuid())
}
Vue.prototype.$addPwaUrlParams = function (url, type) {
  const adid = encodeURIComponent(this.$aesEncrypt(localStorage.getItem('adid')))
  const token = localStorage.getItem('x-auth-token') || ''
  const user = this.$aesEncrypt(JSON.stringify({
    token: token,
    userId: localStorage.getItem('userId') || '',
    phone: localStorage.getItem('phone') || ''
  }))
  if (type === 'object') {
    return {
      adid: adid,
      user: encodeURIComponent(user)
    }
  }
  let c = '?'
  if (url.indexOf('?') > -1) {
    c = '&'
  }
  return url + c + 'adid=' + adid + '&user=' + encodeURIComponent(user)
}

Vue.prototype.$pwaIndexToHome = function (routeJump) {
  const token = localStorage.getItem('x-auth-token') || ''
  // 本地没有token时，获取url的token
  if (!token) {
    let user = this.$aesDecrypt(decodeURIComponent(this.$route.query.user))
    if (user) {
      user = JSON.parse(user)
      if (user && user.token && user.userId && user.phone) {
        localStorage.setItem('x-auth-token', user.token)
        localStorage.setItem('userId', user.userId)
        localStorage.setItem('phone', user.phone)
      }
    }
  }
  if (routeJump !== false) {
    // 跳转到首页
    this.$router.replace({ name: 'Home' })
  }
}

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
